import { render, staticRenderFns } from "./posModal.vue?vue&type=template&id=4baf454b&"
import script from "./posModal.vue?vue&type=script&lang=js&"
export * from "./posModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports